module.exports = __webpack_public_path__ + "web/img/talk-img1.90885427.png";